import React from "react";

import { DrawRequestContext } from "@app/provider";
import TimeslotsForm, {
  TimeslotsFormData,
} from "@app/components/forms/timeslotsForm/timeslotsForm";

import { useNavigate, useParams } from "react-router-dom";
import { DrawRequestTimeslots } from "@app/provider/drawRequest";
import { routes } from "@app/routing";
import { defineMessages, useIntl } from "react-intl";
import { StepperContent } from "@app/components/ui/layout";
import TimeslotsDescription from "@app/components/sampleDraw/mobilePhlebotomy/timeslotsDescription/timeslotsDescription";

import "./modify.scss";

const messages = defineMessages({
  mobilePhlebotomyTimeslotsTitle: {
    id: "mobilePhlebotomyTimeslotsTitle",
    defaultMessage: "Mobile Blood Draw",
  },
  mobilePhlebotomyTimeslotsDescriptionTitle: {
    id: "mobilePhlebotomyTimeslotsDescriptionTitle",
    defaultMessage: "When are some good times for your blood draw?",
  },
  modifySubmit: {
    id: "modifySubmit",
    defaultMessage: "Submit",
  },
});

type Params = {
  orderUidPublic: string;
  testUid: string;
};

const ModifyMobilePhlebotomy: React.FC = () => {
  const intl = useIntl();
  const { orderUidPublic, testUid } = useParams<keyof Params>() as Params;
  const navigate = useNavigate();
  const { updateDrawRequest, isLoading, openUpdateDrawErrorDialog } =
    React.useContext(DrawRequestContext);

  const goBack = () => navigate(-1);

  const handleSubmit = async (data: TimeslotsFormData) => {
    try {
      await updateDrawRequest({
        timeZone: data.timeZone,
        timeSlots: data.timeSlots as DrawRequestTimeslots,
      });
      navigate(routes.testDetailsPage(orderUidPublic, testUid));
    } catch {
      openUpdateDrawErrorDialog();
    }
  };

  return (
    <div className="modify_mp_page">
      <StepperContent
        title={intl.formatMessage(messages.mobilePhlebotomyTimeslotsTitle)}
        subTitle={intl.formatMessage(
          messages.mobilePhlebotomyTimeslotsDescriptionTitle
        )}
        description={<TimeslotsDescription />}
      >
        <TimeslotsForm
          handleBack={goBack}
          handleConfirm={handleSubmit}
          confirmButtonLabel={intl.formatMessage(messages.modifySubmit)}
          isLoading={isLoading}
          isModify
        />
      </StepperContent>
    </div>
  );
};

export default ModifyMobilePhlebotomy;
